<h1 >Update Dealership Data</h1>
<form [formGroup]="form" >
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="dealerId" class="form-label">Dealer Id</label>
            <input type="text" formControlName="dealerId" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerId.errors }" aria-describedby="dealerIdFeedback" />
            <div *ngIf="submitted && f.dealerId.errors" class="invalid-feedback" id="dealerIdFeedback">
                <div *ngIf="f.dealerId.errors.required">Dealership Id is required</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="dealerName" class="form-label">Dealership Name</label>
            <input type="text" formControlName="dealerName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerName.errors }" aria-describedby="dealerNameFeedback" />
            <div *ngIf="submitted && f.dealerName.errors" class="invalid-feedback" id="dealerNameFeedback">
                <div *ngIf="f.dealerName.errors.required">Dealership Name is required</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="dealerGroupName" class="form-label">Group Name</label>
            <input type="text" formControlName="dealerGroupName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerGroupName.errors }" aria-describedby="dealerGroupNameFeedback" />
            <div *ngIf="submitted && f.dealerGroupName.errors" class="invalid-feedback" id="dealerGroupNameFeedback">
                <div *ngIf="f.dealerGroupName.errors.required">Group Name is required</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="dealerCreatePackage" class="form-label">Can Create Package:</label>
            <select class="form-select" formControlName="dealerCreatePackage" [ngClass]="{ 'is-invalid': submitted && f.dealerCreatePackage.errors }" aria-describedby="dealerCreatePackageFeedback">
                <option *ngFor="let selectedVal of canCreatePackageValues" [ngValue]="selectedVal">
                  {{ selectedVal }}
                </option>
              </select>
            <div *ngIf="submitted && f.dealerCreatePackage.errors" class="invalid-feedback" id="dealerCreatePackageFeedback">
                <div *ngIf="f.dealerCreatePackage.errors.required">Cab create Package choice is required</div>
            </div>
        </div>
    </div>
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="dealerAddress" class="form-label">Address</label>
            <input type="text" formControlName="dealerAddress" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerAddress.errors }" aria-describedby="dealerAddressFeedback" />
            <div *ngIf="submitted && f.dealerAddress.errors" class="invalid-feedback" id="dealerAddressFeedback">
                <div *ngIf="f.dealerAddress.errors.required">Dealership Address is required</div>
            </div>
        </div>
            <div class="mb-3 col">
                <label for="dealerState" class="form-label">State</label>
                <select class="form-select" formControlName="dealerState" [ngClass]="{ 'is-invalid': submitted && f.dealerState.errors }" aria-describedby="dealerStateFeedback">
                    <option *ngFor="let dealerState of stateCity" [ngValue]="dealerState.state">
                      {{ dealerState.state }}
                    </option>
                  </select>
                  <div *ngIf="submitted && f.dealerState.errors" class="invalid-feedback" id="dealerStateFeedback">
                    <div *ngIf="f.dealerState.errors.required">State needs to be selected</div>
                </div>
            </div>
            <div class="mb-3 col">
                <label for="dealerCity" class="form-label">City</label>
                <select class="form-select" formControlName="dealerCity" [ngClass]="{ 'is-invalid': submitted && f.dealerCity.errors }" aria-describedby="dealerCityFeedback">
                    <option *ngFor="let dealerCity of cities" [ngValue]="dealerCity">
                      {{ dealerCity }}
                    </option>
                  </select>
                <div *ngIf="submitted && f.dealerCity.errors" class="invalid-feedback" id="dealerCityFeedback">
                    <div *ngIf="f.dealerCity.errors.required">City is required</div>
                </div>
            </div>    
            <div class="mb-3 col">
                <label for="dealerPaymentShow" class="form-label">Dealer Payment Gateway Show</label>
                <select class="form-select" formControlName="dealerPaymentShow" [ngClass]="{ 'is-invalid': submitted && f.dealerPaymentShow.errors }" aria-describedby="dealerPaymentShowFeedback">
                    <option *ngFor="let selectedPaymentValue of dealerPaymentShowValue" [ngValue]="selectedPaymentValue">
                      {{ selectedPaymentValue }}
                    </option>
                  </select>
                <div *ngIf="submitted && f.dealerPaymentShow.errors" class="invalid-feedback" id="dealerPaymentShowFeedback">
                    <div *ngIf="f.dealerPaymentShow.errors.required">Flag is required</div>
                </div>
            </div>    
        </div>

    <div class="row g-3">
        <div class="mb-3 col">
            <label for="dealerContactNumber" class="form-label">Contact Number</label>
            <input type="number" formControlName="dealerContactNumber" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerContactNumber.errors }" aria-describedby="dealerContactNumberFeedback" />
            <div *ngIf="submitted && f.dealerContactNumber.errors" class="invalid-feedback" id="dealerContactNumberFeedback">
                <div *ngIf="f.dealerContactNumber.errors.required">dealerContactNumber is required</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="dealerEmail" class="form-label">Email</label>
            <input type="text" formControlName="dealerEmail" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerEmail.errors }" aria-describedby="dealerEmailFeedback" />
            <div *ngIf="submitted && f.dealerEmail.errors" class="invalid-feedback" id="dealerEmailFeedback">
                <div *ngIf="f.dealerEmail.errors.required">Email is required</div>
                <div *ngIf="f.dealerEmail.errors.email">Email id is invalid</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="dealerInvoiceShow" class="form-label">Dealer Invoice Show</label>
            <select class="form-select" formControlName="dealerInvoiceShow" [ngClass]="{ 'is-invalid': submitted && f.dealerInvoiceShow.errors }" aria-describedby="dealerInvoiceShowFeedback">
                <option *ngFor="let selectedValue of dealerInvoiceShowValue" [ngValue]="selectedValue">
                  {{ selectedValue }}
                </option>
              </select>
            <div *ngIf="submitted && f.dealerInvoiceShow.errors" class="invalid-feedback" id="dealerInvoiceShowFeedback">
                <div *ngIf="f.dealerInvoiceShow.errors.required">Flag is required</div>
            </div>
        </div>    
        <div class="mb-3 col">
            <label for="invoiceType" class="form-label">Dealer Invoice Type</label>
            <select class="form-select" formControlName="invoiceType" [ngClass]="{ 'is-invalid': submitted && f.invoiceType.errors }" aria-describedby="invoiceTypeFeedback">
                <option *ngFor="let selectedPaymentValue of ['Commission','Marketing']" [ngValue]="selectedPaymentValue">
                  {{ selectedPaymentValue }}
                </option>
              </select>
            <div *ngIf="submitted && f.invoiceType.errors" class="invalid-feedback" id="invoiceTypeFeedback">
                <div *ngIf="f.invoiceType.errors.required">Invoice Type is required</div>
            </div>
        </div>    

    </div>
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="dealerMake" class="form-label">Make</label>
            <select multiple="multiple" class="form-control" formControlName="dealerMake" [ngClass]="{ 'is-invalid': submitted && f.dealerMake.errors }" [compareWith]="makeCompare" aria-describedby="dealerMakeFeedback">
                <option *ngFor="let dealerMake of makes" [ngValue]="dealerMake">
                  {{ dealerMake.make }}
                </option>
              </select>
              <div *ngIf="submitted && f.dealerMake.errors" class="invalid-feedback" id="dealerMakeFeedback">
                <div *ngIf="f.dealerMake.errors.required">Make needs to be selected</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="dealerPackage" class="form-label">Packages</label>
            <select multiple="multiple" class="form-control" formControlName="dealerPackage" [ngClass]="{ 'is-invalid': submitted && f.dealerPackage.errors }" [compareWith]="makeComparePackage" aria-describedby="dealerPackageFeedback">
                <option *ngFor="let dealerPackag of packages" [ngValue]="dealerPackag.packageId">
                  {{ dealerPackag.packageName }}
                </option>
              </select>
              <div *ngIf="submitted && f.dealerPackage.errors" class="invalid-feedback" id="dealerPackageFeedback">
                <div *ngIf="f.dealerPackage.errors.required">Packages needs to be selected</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="dealerPlanType" class="form-label">Plan</label>
            <select  class="form-select" formControlName="dealerPlanType" [ngClass]="{ 'is-invalid': submitted && f.dealerPlanType.errors }" aria-describedby="dealerPlanTypeFeedback">
                <option *ngFor="let planType of planTypes" [ngValue]="planType.id">
                  {{ planType.text }}
                </option>
              </select>
              <div *ngIf="submitted && f.dealerPlanType.errors" class="invalid-feedback" id="dealerPlanTypeFeedback">
                <div *ngIf="f.dealerPlanType.errors.required">Plan type needs to be selected</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="dealerType" class="form-label">Dealer Type</label>
            <select  class="form-select" formControlName="dealerType" [ngClass]="{ 'is-invalid': submitted && f.dealerType.errors }" aria-describedby="dealerTypeFeedback">
                <option *ngFor="let dealerType of dealerTypes" [ngValue]="dealerType">
                  {{ dealerType }}
                </option>
              </select>
              <div *ngIf="submitted && f.dealerType.errors" class="invalid-feedback" id="dealerTypeFeedback">
                <div *ngIf="f.dealerType.errors.required">Dealer type needs to be selected</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="dealerGst" class="form-label">GST</label>
            <select  class="form-select" formControlName="dealerGst" [ngClass]="{ 'is-invalid': submitted && f.dealerGst.errors }" aria-describedby="dealerGstFeedback">
                <option *ngFor="let dealerGst of ['Net', 'Full']" [ngValue]="dealerGst">
                  {{ dealerGst }}
                </option>
              </select>
              <div *ngIf="submitted && f.dealerGst.errors" class="invalid-feedback" id="dealerGstFeedback">
                <div *ngIf="f.dealerGst.errors.required">GST needs to be selected</div>
            </div>
        </div>
    </div>
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="dealerBalance" class="form-label">Dealer Balance</label>
            <input type="number" formControlName="dealerBalance" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerBalance.errors }" aria-describedby="dealerBalanceFeedback" />
            <div *ngIf="submitted && f.dealerBalance.errors" class="invalid-feedback" id="dealerBalanceFeedback">
                <div *ngIf="f.dealerBalance.errors.required">Dealer Balance is required</div>
            </div>
        </div>   
        <div class="mb-3 col">
            <label for="dealerBalanceLimit" class="form-label">Dealer Balance Limit</label>
            <input type="number" formControlName="dealerBalanceLimit" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerBalanceLimit.errors }" aria-describedby="dealerBalanceLimitFeedback" />
            <div *ngIf="submitted && f.dealerBalanceLimit.errors" class="invalid-feedback" id="dealerBalanceLimitFeedback">
                <div *ngIf="f.dealerBalanceLimit.errors.required">Dealer Balance Limit is required</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="dealerTotalPayment" class="form-label">Total Business Done- Amount</label>
            <input type="number" formControlName="dealerTotalPayment" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerTotalPayment.errors }" disabled/>
        </div>   
        <div class="mb-3 col">
            <label for="dealerTotalGstPayment" class="form-label">Total Business Done- Taxes(GST)</label>
            <input type="number" formControlName="dealerTotalGstPayment" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerTotalGstPayment.errors }" disabled/>
        </div>   
   
    </div>
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="dealerTotalRefund" class="form-label">Total Refund Received- Amount</label>
            <input type="number" formControlName="dealerTotalRefund" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerTotalRefund.errors }" disabled/>
        </div>   
        <div class="mb-3 col">
            <label for="dealerTotalGstRefund" class="form-label">Total Refund Received- Taxes(GST)</label>
            <input type="number" formControlName="dealerTotalGstRefund" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerTotalGstRefund.errors }" disabled/>
        </div>   
        <div class="mb-3 col">
            <label for="dealerPendingRefund" class="form-label">Total Pending Receivables- Amount</label>
            <input type="number" formControlName="dealerPendingRefund" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerPendingRefund.errors }" disabled/>
        </div>   
        <div class="mb-3 col">
            <label for="dealerGstPendingRefund" class="form-label">Total Pending Receivables- Taxes(GST)</label>
            <input type="number" formControlName="dealerGstPendingRefund" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerGstPendingRefund.errors }" disabled/>
        </div>   
    </div>
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="dealerBankAccountOwner" class="form-label">Account Owner Name</label>
            <input type="text" formControlName="dealerBankAccountOwner" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerBankAccountOwner.errors }" />
        </div>   
        <div class="mb-3 col">
            <label for="dealerBankAccountNumber" class="form-label">Account Number</label>
            <input type="text" formControlName="dealerBankAccountNumber" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerBankAccountNumber.errors }" />
        </div>   
        <div class="mb-3 col">
            <label for="dealerBankIfscCode" class="form-label">IFSC code</label>
            <input type="text" formControlName="dealerBankIfscCode" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerBankIfscCode.errors }" />
        </div> 
    </div>  
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="dealerBankOwnerPan" class="form-label">Receiver PAN number</label>
            <input type="text" formControlName="dealerBankOwnerPan" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerBankOwnerPan.errors }" />
        </div>   
        <div class="mb-3 col">
            <label for="dealerGstId" class="form-label">Receiver GST number</label>
            <input type="text" formControlName="dealerGstId" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerGstId.errors }" />
        </div>   
        <div class="mb-3 col">
            <label for="dealerVpaId" class="form-label">Dealer VPA ID</label>
            <input type="text" formControlName="dealerVpaId" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerVpaId.errors }" />
        </div>   
    </div>
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="makeInvoiceUploadMandatory" class="form-label">Invoice Upload Mandatory</label>
            <select  class="form-select" formControlName="makeInvoiceUploadMandatory" [ngClass]="{ 'is-invalid': submitted && f.makeInvoiceUploadMandatory.errors }" >
                <option *ngFor="let invoiceUpload of [true, false]" [ngValue]="invoiceUpload">
                  {{ invoiceUpload }}
                </option>
              </select>
        </div>   
        <div class="mb-3 col">
            <label for="makeInvoiceValueMandatory" class="form-label">Invoice Value </label>
            <select  class="form-select" formControlName="makeInvoiceValueMandatory" [ngClass]="{ 'is-invalid': submitted && f.makeInvoiceValueMandatory.errors }" >
                <option *ngFor="let invoiceValue of [true, false]" [ngValue]="invoiceValue">
                  {{ invoiceValue }}
                </option>
              </select>
        </div>   
        <div class="mb-3 col">
            <label for="makeAadharUploadMandatory" class="form-label">Aadhar Upload Mandatory</label>
            <select  class="form-select" formControlName="makeAadharUploadMandatory" [ngClass]="{ 'is-invalid': submitted && f.makeAadharUploadMandatory.errors }" >
                <option *ngFor="let aadharUpload of [true, false]" [ngValue]="aadharUpload">
                  {{ aadharUpload }}
                </option>
              </select>
        </div>   
        <div class="mb-3 col">
            <label for="packageEmail" class="form-label">Package Email Notification</label>
            <input type="text" formControlName="packageEmail" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.packageEmail.errors }" />
        </div>   
    </div>

    <div class="mb-3">
        <button [disabled]="loading" class="btn btn-primary" (click)="onSubmit()">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
            Save
        </button>
        <a routerLink="/users" class="btn btn-link">Cancel</a>
    </div>
</form>
<app-add-edit-plan-details></app-add-edit-plan-details>
<app-user-list *ngIf="!isAddMode"></app-user-list>
<app-add-payment *ngIf="!isAddMode"></app-add-payment>
<app-add-payout *ngIf="!isAddMode"></app-add-payout>
<app-package-payment *ngIf="!isAddMode"></app-package-payment>
